import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { ApplicationState } from '../../../store';

function DefaultSettingsRedirect() {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const selectBase64 = useSelector<ApplicationState, string | null>((state) => state.base.data);
  const selectPath = pathname === '/' ? '/w' : pathname;

  useEffect(() => {
    if (!selectBase64) {
      const configs = JSON.parse(window.configs);
      const base64 = ['null', configs.company_id, configs?.default_shop ?? ''].join(';');

      history.push({
        pathname: `${selectPath}/${btoa(base64)}`,
        search,
      });
    } else {
      history.push({
        pathname: `${selectPath}/${selectBase64}`,
        search,
      });
    }
  }, [history, selectBase64]);

  return null;
}

export default DefaultSettingsRedirect;
